<div class="top-bar">
    <img class="logo" [src]="lviLogo">
  </div>
  <div *ngIf="apiError">
    <p>Error {{apiError.httpStatus}} {{apiError.message}}</p>
  </div>

  <div class="main-box" *ngIf="!apiError">
    <div class="form-error" *ngIf="formsInvalid">
      <i style="font-size: 2rem; color: rgb(255, 50, 0);" class="pi pi-exclamation-triangle"></i>
      <p >
        One or more fields contain an error. Please check and try again.</p>
    </div>
  
    <p  *ngIf="submitFail && !personalInfoService.personalForm.get('firstParentMobile')!.value" class="warning">
      *first parent phone number is missing
    </p>
    <p  *ngIf="submitFail && !personalInfoService.personalForm.get('firstParentLastName')!.value" class="warning">
      *first parent last name is missing
    </p>
    <p  *ngIf="submitFail && !personalInfoService.personalForm.get('firstParentFirstName')!.value" class="warning">
      *first parent first name is missing
    </p>
  
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('streetName')!.value" class="warning">
      *street name is missing
    </p>
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('streetNumber')!.value" class="warning">
      *street number is missing
    </p>
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('city')!.value" class="warning">
      *locality is missing
    </p>
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('postCode')!.value" class="warning">
      *post code is missing
    </p>
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('birthDate')!.value" class="warning">
      *birth date is missing
    </p>
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('targetLanguage')!.value" class="warning">
      *selected language is missing
    </p>
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('doctorName')!.value" class="warning">
      *name of GP (General Practitioner) is missing
    </p>
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('doctorPhoneNumber')!.value" class="warning">
      *phone number of GP (General Practitioner) is missing
    </p>
    <p 
      *ngIf="submitFail && medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors['mentalDisorderDescriptionMissing']"
      class="warning">
      *description about mental disorder is missing
    </p>
    <p 
      *ngIf="submitFail && medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors['medicineDoseMissing']"
      class="warning">
      *quantity of medicine is missing
    </p>
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('hadTetanusVaccination')!.value" class="warning">
      *tetanus vaccination (yes or no) is missing
    </p>
    <p 
      *ngIf="submitFail && medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors['skinTestResultMissing']"
      class="warning">
      *result of skin test is missing
    </p>
    <p 
      *ngIf="submitFail && medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors['substanceMissing']"
      class="warning">
      *name of substance is missing
    </p>
    <p  *ngIf="submitFail && (medicalInfoService.medicalForm.get('isIncontinent')!.value == null || 
    medicalInfoService.medicalForm.get('isIncontinent')!.value == undefined)" class="warning">
      *incontinent (yes or no) is missing
    </p>
    <p  *ngIf="submitFail && (medicalInfoService.medicalForm.get('isQuicklyTired')!.value == null || 
    medicalInfoService.medicalForm.get('isQuicklyTired')!.value == undefined)" class="warning">
      *quickly tired (yes or no) is missing
    </p>
    <p  *ngIf="submitFail && (medicalInfoService.medicalForm.get('isSensitiveToChilling')!.value == null || 
    medicalInfoService.medicalForm.get('isSensitiveToChilling')!.value == undefined)" class="warning">
      *sensitive to chilling (yes or no) is missing
    </p>
    <p  *ngIf="submitFail && (medicalInfoService.medicalForm.get('canSportWithoutRisk')!.value == null || 
    medicalInfoService.medicalForm.get('canSportWithoutRisk')!.value == undefined)" class="warning">
      *can sport without risk (yes or no) is missing
    </p>
    <p 
      *ngIf="submitFail && medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors['riskDescriptionToSportMissing']"
      class="warning">
      *description about risk is missing
    </p>
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('needMedicalTreatment')!.value" class="warning">
      *need medical treatment (yes or no) is missing
    </p>
    <p 
      *ngIf="submitFail && medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors['medicineDoseMissing']"
      class="warning">
      *quantity of medicine is missing
    </p>
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('bloodType')!.value" class="warning">
      *blood type is missing
    </p>
    <p  *ngIf="submitFail && !medicalInfoService.medicalForm.get('emergencyContactAddress')!.value" class="warning">
      *emergency contact address is missing
    </p>
    <p  *ngIf="submitFail && !schoolInfoService.schoolForm.get('studyDutchInSchool')!.value == null" class="warning">
      *study Dutch in school (yes or no) is missing
    </p>
    <p 
      *ngIf="submitFail && schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors['missingDutchStudyInfo']"
      class="warning">
      *information on Dutch study is missing
    </p>
    <p  *ngIf="submitFail && !schoolInfoService.schoolForm.get('studyEnglishInSchool')!.value == null" class="warning">
      *study English in school (yes or no) is missing
    </p>
    <p 
      *ngIf="submitFail && schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors['missingEnglishStudyInfo']"
      class="warning">
      *information on English study is missing
    </p>
    <p  *ngIf="submitFail && !schoolInfoService.schoolForm.get('studyFrenchInSchool')!.value == null" class="warning">
      *study French in school (yes or no) is missing
    </p>
    <p 
      *ngIf="submitFail && schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors['missingFrenchStudyInfo']"
      class="warning">
      *information on French study is missing
    </p>
    <p  *ngIf="submitFail && !schoolInfoService.schoolForm.get('frequencySpeakingWithFamily')!.value" class="warning">
      *use target language with family (often, sometimes, never) is missing
    </p>
    <p  *ngIf="submitFail && !schoolInfoService.schoolForm.get('frequencySpeakingWithFriends')!.value" class="warning">
      *use target language with friends (often, sometimes, never) is missing
    </p>
    <p  *ngIf="submitFail && !schoolInfoService.schoolForm.get('hasLearningDifficulty')!.value" class="warning">
      *has learning difficulty (yes or no) is missing
    </p>
    <p 
      *ngIf="submitFail && schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors['testDateMissing']"
      class="warning">
      *test date is missing
    </p>
    <p  *ngIf="submitFail && !schoolInfoService.schoolForm.get('hadLanguageTest')!.value" class="warning">
      *had language test (yes or no) is missing
    </p>
    <p  *ngIf="submitFail && !schoolInfoService.schoolForm.get('isComingWithFriends')!.value" class="warning">
      *coming with friends (yes or no) is missing
    </p>
    <p 
      *ngIf="submitFail && schoolInfoService.schoolForm.errors && schoolInfoService.schoolForm.errors['friendNameMissing']"
      class="warning">
      *friend name is missing
    </p>
  
    <app-personal-info [booking]="booking" [submitFail]="submitFail"></app-personal-info>
  
    <app-medical-info [booking]="booking" [submitFail]="submitFail"></app-medical-info>
  
    <app-school-info [booking]="booking" [submitFail]="submitFail"></app-school-info>
  
    <div [formGroup]="agreementForm">
      <div class="parental-authorisation">
        <h3 >
          PARENTAL AUTHORISATION
        </h3>
        <ul class="conditions">
          <li >
            I will not hold the staff or management responsible in case an underage participant doesn't respect the
            programme rules.
          </li>
          <li >
            I agree that during the placement, only the target language will be spoken by all the participants (if their
            level allows it.)
          </li>
          <li >
            I accept that, in case of repeated bad behaviour, or if the participant persists in refusing to speak the
            target
            language, they may be expelled from the programme under my own responsibility and without compensation after
            being notified by phone.
          </li>
          <li >
            I authorize staff and management to take any urgent decision on my behalf concerning the health of the minor,
            after a phone call.
          </li>
        </ul>
        <div class="agree-to-terms" >
          <input type="checkbox" formControlName="agreeWithTerms" id="consent-checkbox">
          I have read, understand and agree to the above terms*
        </div>
      </div>
  
      <div class="student-picture-autorization" >
        <div>
          <input type="checkbox" formControlName="agreeToTakeStudentPicture" id="picture-consent-checkbox">
        </div>
        <div>
          I authorise my child to be photographed and/or filmed during the Easy Languages Languages camp in Bruges and
          that the photos/videos may be shared with the parents/guardians of the participants as well as being used for
          promotional purposes by Easy Languages and its local partner in Bruges.
          This permission is valid for the duration of my child's course. I can withdraw my permission in writing at any
          time.
        </div>
      </div>
    </div>
  
    <div class="button-wrap">
      <i *ngIf="sendingForm" class="pi pi-spin pi-spinner" style="font-size: 3em; color: rgb(0,122,217)"></i>
      <button [disabled]="!agreementForm.value.agreeWithTerms" pButton type="button" label="Send vademecum"
        (click)="sendVademecum()" id="send-button"></button>
    </div>
  
  </div>